import {
  ABORT_SUBMIT_WORKFLOW_API_REQUEST,
  CLEAR_WORKFLOW,
  GET_SIGNOFF_TRANSLATION_SUCCESS,
  ON_SUBMIT_END,
  ON_SUBMIT_START,
  PERFORM_WORKFLOW_STEP_SUCCESS,
  SET_DECISION_TREE_IFRAME_SRC,
  SET_FINISH_SUBMIT,
  SET_INSPECTION_MEASUREMENT_DATA_IFRAME_SRC,
  SET_IS_WORKFLOW_REQUEST_PENDING,
  SET_MIDDLE_PANEL_LOADING,
  SET_SUBMIT_WORKFLOW_RESULT,
  START_AUTO_CHECKING,
  START_SUBMIT_WORKFLOW_API_REQUEST,
  STOP_AUTO_CHECKING,
} from '../actions/WorkflowActions';

const workflowState = {
  step: 'Initiation',
  error: '',
  workFlowSteps: [],
  formIsAutoChecking: false,
  finishSubmit: false, // used when submit is interrupted because of token expiration, so that blue banner handles auto navigation or next steps
  formIsSubmitting: false, // is used for validations
  formSubmitType: undefined, // save | sign-off | bulk-upload | batch-submit
  requiresSignature: false,
  submitWorkflowResult: null,
  commandName: '',
  commandArgument: '',
  submitWorkflowApiCompleted: false, // controls 'Form Saved Successfully' message (don't show message from prev call)
  targetForm: '',
  isWorkflowRequestPending: false, // true, every time we use next api: /submitworkflowdata, /SaveDraft, /bulkupload, /RequestControlPrint, /authentication, /batchupdate
};

export default function workflowReducer(state = workflowState, action) {
  switch (action.type) {
    case SET_FINISH_SUBMIT:
      return {
        ...state,
        finishSubmit: action.payload.value,
      };
    case START_AUTO_CHECKING:
      return {
        ...state,
        formIsAutoChecking: true,
      };
    case STOP_AUTO_CHECKING:
      return {
        ...state,
        formIsAutoChecking: false,
      };
    case SET_SUBMIT_WORKFLOW_RESULT:
      return {
        ...state,
        submitWorkflowResult: { ...action.payload.submitWorkflowResult },
        submitWorkflowApiCompleted: true,
      };
    case PERFORM_WORKFLOW_STEP_SUCCESS:
      return {
        ...state,
        workFlowSteps: action.workFlowSteps,
        submitWorkflowApiCompleted: true,
      };

    case ON_SUBMIT_START:
      return {
        ...state,
        formIsSubmitting: true,
        formSubmitType: action.formSubmitType,
        requiresSignature: action.requiresSignature,
        signOffMeaning: action.meaning,
        workFlowSteps: [],
        commandName: action.commandName ? action.commandName : '',
        commandArgument: action.commandArgument ? action.commandArgument : '',
        latestSubmitType: action.formSubmitType,
        targetForm: action.formKey,
      };

    case ON_SUBMIT_END:
      return {
        ...state,
        formIsSubmitting: false,
        formSubmitType: undefined,
        requiresSignature: false,
        commandName: '',
        commandArgument: '',
      };

    case START_SUBMIT_WORKFLOW_API_REQUEST:
      return {
        ...state,
        submitWorkflowApiCompleted: false,
      };

    case ABORT_SUBMIT_WORKFLOW_API_REQUEST:
      return {
        ...state,
        submitWorkflowApiCompleted: true,
      };
    case GET_SIGNOFF_TRANSLATION_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case SET_DECISION_TREE_IFRAME_SRC: {
      return {
        ...state,
        decisionTreeIframeSrc: action.decisionTreeIframeSrc,
      };
    }
    case SET_INSPECTION_MEASUREMENT_DATA_IFRAME_SRC: {
      return {
        ...state,
        inspectionMeasurementDataIframeSrc: action.inspectionMeasurementDataIframeSrc,
      };
    }
    case SET_MIDDLE_PANEL_LOADING: {
      return {
        ...state,
        decisionTreeIframeSrc: undefined,
        inspectionMeasurementDataIframeSrc: undefined,
      };
    }
    case SET_IS_WORKFLOW_REQUEST_PENDING: {
      return {
        ...state,
        isWorkflowRequestPending: action.payload.flag,
      };
    }
    case CLEAR_WORKFLOW: {
      return workflowState;
    }
    default:
      return state;
  }
}
